<template>
	<div>
		<tableBox  :url="'/Flat/SelUserPlaceOrderSamples'"  :ifState="true" :ifAppointment="true" :ifScreen="true" :ifSearch="true"    :columns="columns"></tableBox>
	</div>
</template>
<script>
	import tableBox from '../../../components/tableBox.vue'
	export default {
		name:'/core/deliveryTest',
		components: {
			tableBox
		},
		data() {
			return {
				columns: [
					
					{
						title: '仪器名称',
						dataIndex: 'instrumentName',
						key: 'instrumentName'
				
					},
					{
						title: '平台',
						key: 'labname',
						dataIndex: 'labname',
						
						aligh:'center'
					},
					{
						title: '订单号',
						dataIndex: 'orderNo',
						key: 'orderNo'
					
					},
					{
						title: '总数',
						dataIndex: 'totalItems',
						key: 'totalItems'
					
					},
				
					{
						title: '总价（元）',
						dataIndex: 'orderAmount',
						key: 'orderAmount',
						
					
					},
					{
						title: '下单人',
						key: 'buyerName',
						dataIndex: 'buyerName',
					},
					// {
					// 	title: '订单状态',
					// 	key: 'orderStatevalue',
					// 	dataIndex: 'orderStatevalue',
					// 	// scopedSlots: {
					// 	// 	customRender: 'payType'
					// 	// }
					// },
					{
						title: '审核状态',
						key: 'sampleOrderState',
						dataIndex: 'sampleOrderState',
						scopedSlots: {
							customRender: 'sampleOrderState1'
						}
					},
					{
						title: '处理人',
						key: 'handlerName',
						dataIndex: 'handlerName',
						
					},
					{
						title: '下单时间',
						key: 'createTime',
						dataIndex: 'createTime',
						scopedSlots: {
							customRender: 'createTime'
						},
						aligh:'center'
					},
					
					{
						title: '样品',
						dataIndex: 'items',
						scopedSlots: {
							customRender: 'itemss'
						},
						width:250,
						
					},
					
					{
						title: '操作',
						dataIndex: 'deliveryTestOpe',
						scopedSlots: {
							customRender: 'deliveryTestOpe'
						},
						width:220
					},
				],
				
			}
		}
	};
</script>

<style>
</style>
